(function () {
  function initProductHero(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.nhProductHeroInit === "true") return;

    var hero = sectionRoot.querySelector(".nhph[data-section-id]");
    if (!hero) return;

    sectionRoot.dataset.nhProductHeroInit = "true";
    var sid = hero.dataset.sectionId;

    var mainImg = sectionRoot.querySelector("#nhph-main-img-" + sid);
    var mainEl = sectionRoot.querySelector(".nhph-main");
    var lens = mainEl ? mainEl.querySelector(".nhph-zoom-lens") : null;
    var thumbs = sectionRoot.querySelectorAll(".nhph-thumb");

    function currentZoomSrc() {
      if (mainEl && mainEl.getAttribute("data-zoom-src")) return mainEl.getAttribute("data-zoom-src");
      return mainImg ? mainImg.currentSrc || mainImg.src : "";
    }
    function refreshLensBg() {
      if (lens) lens.style.backgroundImage = "url('" + currentZoomSrc() + "')";
    }
    refreshLensBg();

    // Select a gallery image (shared by thumbnail clicks + lightbox arrows)
    function showImage(btn) {
      if (!btn) return;
      thumbs.forEach(function (b) { b.classList.remove("is-active"); });
      btn.classList.add("is-active");
      if (mainEl && btn.dataset.zoom) mainEl.setAttribute("data-zoom-src", btn.dataset.zoom);
      if (!mainImg) return;
      mainImg.classList.add("is-fading");
      var next = new Image();
      next.onload = function () {
        mainImg.src = btn.dataset.src;
        mainImg.srcset = btn.dataset.srcset || "";
        mainImg.classList.remove("is-fading");
        refreshLensBg();
      };
      next.src = btn.dataset.src;
    }

    if (mainImg && thumbs.length) {
      thumbs.forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (btn.classList.contains("is-active")) return;
          showImage(btn);
        });
      });
    }

    // ---- Lens hover-zoom (shared by main image + lightbox; desktop fine pointer) ----
    var canHover = window.matchMedia("(min-width: 990px) and (hover: hover)");

    function attachLensZoom(hoverEl, lensEl, getSrc) {
      if (!hoverEl || !lensEl) return;
      hoverEl.addEventListener("mouseenter", function () {
        if (!canHover.matches) return;
        lensEl.style.backgroundImage = "url('" + getSrc() + "')";
        hoverEl.classList.add("is-zooming");
      });
      hoverEl.addEventListener("mousemove", function (e) {
        if (!canHover.matches) return;
        var r = hoverEl.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        lensEl.style.backgroundPosition = x + "% " + y + "%";
      });
      hoverEl.addEventListener("mouseleave", function () {
        hoverEl.classList.remove("is-zooming");
      });
    }

    attachLensZoom(mainEl, lens, currentZoomSrc);

    // ---- Lightbox (tap/click to open, all devices) ----
    var lightbox = sectionRoot.querySelector("#nhph-lb-" + sid);
    var lbStage = lightbox ? lightbox.querySelector(".nhph-lb-stage") : null;
    var lbImg = lightbox ? lightbox.querySelector("img") : null;
    var lbLens = lightbox ? lightbox.querySelector(".nhph-lb-lens") : null;
    var lbClose = lightbox ? lightbox.querySelector(".nhph-lb-close") : null;
    var lbPrev = lightbox ? lightbox.querySelector(".nhph-lb-prev") : null;
    var lbNext = lightbox ? lightbox.querySelector(".nhph-lb-next") : null;
    var lbCurrent = lightbox ? lightbox.querySelector(".nhph-lb-current") : null;
    var lbTotal = lightbox ? lightbox.querySelector(".nhph-lb-total") : null;
    var thumbList = Array.prototype.slice.call(thumbs);
    var lbIndex = 0;

    function lbActiveIndex() {
      var idx = 0;
      thumbList.forEach(function (b, i) { if (b.classList.contains("is-active")) idx = i; });
      return idx;
    }
    // Render the current lightbox image and keep the main gallery in sync,
    // so closing the lightbox lands on the image you were viewing.
    function lbRender() {
      var btn = thumbList[lbIndex];
      if (!btn || !lbImg) return;
      var zoom = btn.dataset.zoom || btn.dataset.src;
      showImage(btn);
      lbImg.src = zoom;
      if (lbLens) lbLens.style.backgroundImage = "url('" + zoom + "')";
      if (lbCurrent) lbCurrent.textContent = lbIndex + 1;
    }
    function lbGo(delta) {
      if (thumbList.length < 2) return;
      lbIndex = (lbIndex + delta + thumbList.length) % thumbList.length;
      lbRender();
    }

    function openLightbox() {
      if (!lightbox || !lbImg) return;
      lbIndex = lbActiveIndex();
      lbImg.src = currentZoomSrc();
      if (lbCurrent) lbCurrent.textContent = lbIndex + 1;
      if (lbStage) lbStage.classList.remove("is-zooming");
      lightbox.hidden = false;
      document.body.style.overflow = "hidden";
      if (lbClose) lbClose.focus();
    }
    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.body.style.overflow = "";
      if (lbStage) lbStage.classList.remove("is-zooming");
    }

    // Same lens hover-zoom as the main image, reused for the lightbox.
    attachLensZoom(lbStage, lbLens, currentZoomSrc);

    if (lbTotal) lbTotal.textContent = thumbList.length;
    // Single-image products have no thumbnails → nothing to navigate.
    if (thumbList.length < 2) {
      if (lbPrev) lbPrev.hidden = true;
      if (lbNext) lbNext.hidden = true;
      var lbCounter = lightbox ? lightbox.querySelector(".nhph-lb-counter") : null;
      if (lbCounter) lbCounter.hidden = true;
    }
    if (lbPrev) lbPrev.addEventListener("click", function () { lbGo(-1); });
    if (lbNext) lbNext.addEventListener("click", function () { lbGo(1); });

    if (mainEl) {
      mainEl.addEventListener("click", openLightbox);
    }
    if (lbClose) lbClose.addEventListener("click", closeLightbox);
    if (lightbox) {
      lightbox.addEventListener("click", function (e) {
        if (e.target === lightbox) closeLightbox();
      });
    }
    document.addEventListener("keydown", function (e) {
      if (!lightbox || lightbox.hidden) return;
      if (e.key === "Escape") closeLightbox();
      else if (e.key === "ArrowLeft") lbGo(-1);
      else if (e.key === "ArrowRight") lbGo(1);
    });

    var sticky = document.querySelector(".nhph-sticky-" + sid);
    var atc = sectionRoot.querySelector(".nhph-atc");
    if (sticky && atc && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle("is-visible", show);
          sticky.setAttribute("aria-hidden", show ? "false" : "true");
        });
      }, { threshold: 0 });
      io.observe(atc);
    }

    var accs = sectionRoot.querySelectorAll(".nhph-acc");
    accs.forEach(function (acc) {
      acc.addEventListener("toggle", function () {
        if (!acc.open) return;
        accs.forEach(function (other) {
          if (other !== acc) other.open = false;
        });
      });
    });

  }

  function initAllProductHeroes() {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(initProductHero);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllProductHeroes);
  } else {
    initAllProductHeroes();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initProductHero(event.target);
  });
})();
